import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { GetDetail, Update } from '../../web_api/api'
import Swal from 'sweetalert2'
import 'react-photo-view/dist/react-photo-view.css';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { FaImages } from "react-icons/fa";
import { FiChevronRight } from 'react-icons/fi'
import '../../branch/branch.css'
export default function PromoCreate() {
    const location = useLocation()
    const ID = location.pathname.split('/')[2]
    const [detailData, setDetailData] = useState([])
    const [image, setImage] = useState(null)
    const [title, setTitle] = useState('')
    const [subTitle, setSubTitle] = useState('')
    const [description, setDescription] = useState('')


    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setImage(e.target.files[0])
        }
    }
    const update = async () => {
        const formData = new FormData()
        formData.append('title', title)
        formData.append('sub_title', subTitle)
        formData.append('description', description)
        if (image) {
            formData.append('promotions', image)
        }

        if (!detailData?.image && !image) {
            Swal.fire({
                title: 'Need Image!',
                text: 'Try again!',
                icon: 'error',
                showConfirmButton: false,
                timer: 2000
            })
        } else {
            await Update('promotion-page/', ID, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        }
    }

    useEffect(() => {
        const detail = async () => {
            const res = await GetDetail('promotion-page/', ID)
            setDetailData(res.data)
            setTitle(res.data?.title)
            setSubTitle(res.data?.sub_title)
            setDescription(res.data?.description)


        }
        detail()
    }, [])
    return (
        <div className='branch-page'>
            <div className='branch-breadcrumb'>
                <Link to='/promotion'>Promotions</Link>
                <FiChevronRight className='separator' size={14} />
                <span className='current'>Update Promotion</span>
            </div>

            <div className='branch-page-title'>Update Promotion</div>
            <div className='branch-page-subtitle'>Edit promotion details</div>

            <div className='branch-card'>
                <div className='branch-card-body'>
                    <div className='branch-form-grid'>
                        {/* LEFT COLUMN */}
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Promotion Details</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='title'>Title</label>
                                    <input type='text' id='title' value={title} className='branch-input' onChange={(e) => setTitle(e.target.value)} />
                                </div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='subTitle'>Sub Title</label>
                                    <input type='text' id='subTitle' value={subTitle} className='branch-input' onChange={(e) => setSubTitle(e.target.value)} />
                                </div>
                            </div>

                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Content</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='description'>Description</label>
                                    <textarea id='description' value={description} className='branch-input' onChange={(e) => setDescription(e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* RIGHT COLUMN */}
                        <div>
                            <div className='branch-form-section'>
                                <div className='branch-form-section-title'>Image</div>
                                <div className='branch-field'>
                                    <label className='branch-field-label' htmlFor='imageInput'>
                                        Image {detailData?.image === null && <span className='required'>*</span>}
                                    </label>
                                    <input type='file' id='imageInput' className='branch-input' onChange={handleImageChange} />
                                </div>
                                <div className='branch-field'>
                                    { (image || detailData?.image) && (
                                        <div className='branch-preview-grid'>
                                            <div className='branch-preview-item' style={{ width: '200px', height: '150px' }}>
                                                <PhotoProvider>
                                                    <PhotoView src={image ? URL.createObjectURL(image) : detailData.image}>
                                                        <img src={image ? URL.createObjectURL(image) : detailData.image} alt='preview' style={{cursor: 'pointer', width: '100%', height: '100%', objectFit: 'cover'}} />
                                                    </PhotoView>
                                                </PhotoProvider>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='branch-form-footer'>
                        <Link to='/promotion' className='branch-btn branch-btn-outline'>Cancel</Link>
                        <button className='branch-btn branch-btn-primary' onClick={update}>Update</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
